// Third-party
import React from 'react';

// Components
import { PrimaryLink } from '../buttons';

// Utils
import { ACTIVITIES, ACTIVITY_TYPES, ACTIVITY_FORMAT, formatActivityData } from '../../../utils/activity-log';
import { formatMessage, FormattedMessage } from '../../../utils/i18n';
import { formatEventDate } from '../../../utils/time';
import Activity from '@/types/activity';

interface Props {
  activity: Activity;
  format: ACTIVITY_FORMAT;
  viewContactActivity: (id: string) => void;
}

const ActivityCard = ({ activity, format, viewContactActivity }: Props) => {
  const { i18nKey, color, icon, i18nActionKey } = ACTIVITIES[activity.type];

  const renderIcon = () => {
    switch (activity.type) {
      case ACTIVITY_TYPES.DOWNLOAD_PROPOSAL: {
        return (
          <>
            <div className="checkmark-container" style={{ backgroundColor: color }}>
              <i className={`icon-${icon}`} />
            </div>
            <span className="activity-action" style={{ color }}>
              {formatMessage(i18nActionKey).toUpperCase()}
            </span>
          </>
        );
      }
      default: {
        return (
          <>
            <i className={`icon-${icon}`} style={{ color }} />
            <span className="activity-action" style={{ color }}>
              {formatMessage(i18nActionKey).toUpperCase()}
            </span>
          </>
        );
      }
    }
  };

  const onViewActivityClick = () => {
    if (!activity.values || !activity.values.user) {
      return null;
    }

    return viewContactActivity(activity.values.user._id);
  };

  return (
    <div className="activity-card">
      <div className="d-flex align-items-center">
        {renderIcon()}
        <span className="activity-date">{formatEventDate(activity.at)}</span>
      </div>

      <span className="activity-content" data-private data-dd-privacy="mask">
        {formatMessage(`ActivityLog.${i18nKey}.${format}`, formatActivityData(activity))}
      </span>

      <div className="view-activity">
        <PrimaryLink dark onClick={() => onViewActivityClick()}>
          <FormattedMessage id="ActivityLog.ViewActivity" />
        </PrimaryLink>
      </div>
    </div>
  );
};

export default ActivityCard;
